const {h, render, Component} = require('preact');
const Helper = require('./helper')

class Status extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let status = this.props.claimDetails.status
    let formattedStatus = Helper.getFormattedDateStatus(status)
    if (status){
      return (
        <tr>
          <td>{I18n.translate("js.modules.support.status")}</td>
          <td>{formattedStatus.dateStatus} <span class="claim-days">{formattedStatus.days}</span></td>
        </tr>
      );
    }
    return null;
  }
}

module.exports = Status
